'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncContainer = require('./containers/asyncContainer');

var _asyncContainer2 = _interopRequireDefault(_asyncContainer);

var _Typeahead = require('./Typeahead.react');

var _Typeahead2 = _interopRequireDefault(_Typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncContainer2.default)(_Typeahead2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/AsyncTypeahead.react.js
// module id = 1034
// module chunks = 0